var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    props = _objectWithoutProperties(_ref, ["styles"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50",
    height: "50",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: "40",
    cy: "40",
    r: "40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.87 35.69c0 .59-.78 1.37-1.37 1.37H33.8c-.6 0-1.37-.78-1.37-1.37v-8.25c0-.6.78-1.38 1.37-1.38H45.5c.6 0 1.37.78 1.37 1.38v8.25zM57.75 33c1.14-.55 2.44.54 2.15-1.46-.92-6.2-7.45-7.5-7.45-7.5-.56-.18-.8.12-.99.69-.19.56-.26 1.17.3 1.36l.03.01c.19.07 1.26.5 2.22 1.33.96.85 1.78 2 1.79 3.75 0 .63-.11 1.35-.39 2.18a13.21 13.21 0 0 0-.66 4.2c0 2.76.74 5.35 1.43 7.64.7 2.3 1.35 4.32 1.34 5.77-.01.8-.27 1.27-.65 1.62-.38.34-.94.54-1.51.53a2.3 2.3 0 0 1-1.52-.53c-.38-.35-.64-.82-.65-1.62 0-4.49-.82-6.97-2.17-8.32-.8-.8-1.51-.64-2.08-.79V26.75c0-1.54-1.5-2.75-3.04-2.75H33.2a2.82 2.82 0 0 0-2.82 2.8v27.45s-1.37 0-1.37 1.37C29 57 30.37 57 30.37 57h18.57s1.37 0 1.37-1.38c0-1.37-1.37-1.37-1.37-1.37V43.94c.68 0 1.08.35 1.37.69.78.87 1.02 2.46 1.03 6.35-.01 1.35.23 2.5 1.07 3.23.83.74 1.9 1.08 2.95 1.08 1.05 0 2.11-.34 2.95-1.08a4.2 4.2 0 0 0 1.37-3.23c0-2.01-.75-4.13-1.43-6.4-.69-2.26-1.34-4.64-1.34-7 0-1.18.16-2.36.56-3.53.11-.35.2-.7.28-1.04z",
    fill: "#FFF"
  })));
});